export const bidiotvMoviesTh=[
    {
        id: 1,
        contents: 10,
        name: {
          th:'ผจญภัย'
        },
        videos: [
          {
            duration: "Watch Now",
            id: 100,
            name: "Bucket list opportunity- Siberian ice rafting is 100% unique",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 102,
            name: "Muniellos One of the most exclusive forests in the world",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 103,
            name: "This 85-year-old grandma games harder than people half her age",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 104,
            name: "With this e-bike, you can cycle on water",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 105,
            name: "The fascinating investigation findings after the Titanic sank",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.jpg",
            filename: "",
          },
        ]
    },
    {
        id: 2,
        contents: 10,
        name: {
          th:'ทำอาหาร'
        },
        videos: [
          {
            duration: "Watch Now",
            id: 200,
            name: "All the recipes Gigi & Bella Hadid have cooked in quarantine",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 201,
            name: "Craving someothing sweet Try making this rainbow pudding shake",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+someothing+sweet+Try+making+this+rainbow+pudding+shake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+someothing+sweet+Try+making+this+rainbow+pudding+shake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 202,
            name: "Craving something sweet Make a 'Sugar Bomb' milkshake",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Make+a+'Sugar+Bomb'+milkshake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Make+a+'Sugar+Bomb'+milkshake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 203,
            name: "Craving something sweet Try making this strawberry milkshake",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 204,
            name: "Craving something sweet Try making this yummy Oreo milkshake!",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.jpg",
            filename: "",
          },
        ]
    },
    {
      id: 3,
      contents: 10,
      name: {
        th:'ฮอลลีวูด'
      },
      videos: [
        {
          duration: "Watch Now",
          id: 300,
          name: "Besides Ariana Grande, here are 5 stars Victoria Mone't wrote music for",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone't+wrote+music+for.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone't+wrote+music+for.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 301,
          name: "Five Fascinating facts about David Attenborough's life",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Five+Fascinating+facts+about+David+Attenborough's+life.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Five+Fascinating+facts+about+David+Attenborough's+life.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 302,
          name: "Power pop from Demi Lovato, Sam Smith and even Kelly Rowland",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 303,
          name: "Queen's legendary guitarist is ready to get 'preachy' about veganism",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Queen's+legendary+guitarist+is+ready+to+get+'preachy'+about+veganism.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Queen's+legendary+guitarist+is+ready+to+get+'preachy'+about+veganism.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 304,
          name: "How Hollywood got bit by 'Parasite' star Park So-Dam",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/How+Hollywood+got+bit+by+'Parasite'+star+Park+So-Dam.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/How+Hollywood+got+bit+by+'Parasite'+star+Park+So-Dam.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 305,
          name: "3 things James Gunn told `GotG_ fans during his watch party",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/3+things+James+Gunn+told+%60GotG_+fans+during+his+watch+party.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/3+things+James+Gunn+told+%60GotG_+fans+during+his+watch+party.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 306,
          name: "5 Times Elle Fanning was a total red carpet princess",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 307,
          name: "All the FBF you need of Victoria Beckham as Posh Spice",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 308,
          name: "All the red carpets Anya Taylor-Joy came to slay",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 309,
          name: "Black Widow fans in the UK rejoicing over earlier release date",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 310,
          name: "Cynthia Rowley gave birth to a Gen-Z Blair Waldorf",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 311,
          name: "Disney reportedly in talks to release _Black Widow_ straight to streaming",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Disney+reportedly+in+talks+to+release+_Black+Widow_+straight+to+streaming.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Disney+reportedly+in+talks+to+release+_Black+Widow_+straight+to+streaming.jpg",
          filename: "",
        },
      ]
    },
    {
      id: 4,
      contents: 10,
      name: {
        en:'กีฬาและเกม'
      },
      videos: [
        {
          duration: "Watch Now",
          id: 400,
          name: "Esports - Can the industry save a country's economy",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country's+economy.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country's+economy.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 401,
          name: "Esports news LDLC, Rocket League, BBC and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 402,
          name: "Esports news LEC Winners, TSM, FPX and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 403,
          name: "Esports news Poke'mon, ESL One, Popular events and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Poke'mon%2C+ESL+One%2C+Popular+events+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Poke'mon%2C+ESL+One%2C+Popular+events+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 404,
          name: "Esports news Dreamhack, Twitch, Sinatraa and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 405,
          name: "Gaming Industry Updates EVO, Summer Game Fest, GDC and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 406,
          name: "Gaming Industry Updates Germany, Travis Scott, LoL MSI and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 407,
          name: "Gaming Industry Updates Ubisoft, Switch, Capcom and more",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.jpg",
          filename: "",
        }
      ]
    },
]


// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_th.js